const REGIONAL_IDS = "88,89,90,91,92,93,94";

const FALVORITE_REGIONAL_IDS = [88, 89, 90, 91, 92, 93, 94];

export { FALVORITE_REGIONAL_IDS };
export default REGIONAL_IDS;
